<template>
  <div class="mt-3">
    <div class="row">
      <div class="col-md-4">
        <div class="bg-blue bigText evalBlock mb-3">
          <div class="evalTitle">
            <h3>{{$t("Exposition aux risques")}}</h3>
          </div>
          <div class="text-center">
            <p><img class="img-fluid img-risques" :src="'/img/jauge/'+value.risques_nb_eval_score3+'.png'"/></p>
            <p class="bigText2"><b>{{value.risques_nb_presents?value.risques_nb_presents:0}} {{$t("risque")}}<span v-if="value.risques_nb_presents>1">s</span> {{$t("présent")}}<span v-if="value.risques_nb_presents>1">s</span></b> {{$t("sur")}} {{value.risques_nb_eval}} {{$t("évalué")}}<span v-if="value.risques_nb_eval>1">s</span></p>
            <p>
              <small v-if="value.risques_nb_eval_score3==0">{{$t("Le bien est situé dans une zone peu sensible à des risques naturels ou technologiques")}}<span v-if="value.risques_label!=''"> : {{ value.risques_label }}</span></small>
              <small v-if="value.risques_nb_eval_score3==1">{{$t("Le bien est situé dans une zone pouvant être impactée par des risques naturels ou technologiques")}}<span v-if="value.risques_label!=''"> : {{ value.risques_label }}</span></small>
              <small v-if="value.risques_nb_eval_score3==2">{{$t("Le bien est situé dans une zone présentant de nombreux risques naturels ou technologiques")}}<span v-if="value.risques_label!=''"> : {{ value.risques_label }}</span></small>
            </p>
          </div>
        </div>
        <div class="bg-blue bigText evalBlock mb-3">
          <div class="evalTitle">
            <h3><span class="hight">{{value.risques_docs_infos.length}}</span> {{$t("document")}}<span v-if="value.risques_docs_infos.length>1">s</span> {{$t("d'information")}}<span v-if="value.risques_docs_infos.length>1">s</span> {{$t("préventive")}}<span v-if="value.risques_docs_infos.length>1">s</span> {{$t("disponible")}}<span v-if="value.risques_docs_infos.length>1">s</span></h3>
          </div>
          <ul class="nolist bigspace">
            <li v-for="(doc,di) in value.risques_docs_infos" :key="di" class="mt-3">
              <div class="row">
                <div class="col-md-5 line-height-normal">
                  {{doc.title}}
                </div>
                <div class="col-md-7 text-right">
                  <a :href="doc.url" target="_blank" class="btn btn-gold btn-sm px-2" right>{{$t("Télécharger")}} <i class="icon-download-from-cloud-100"></i></a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-md-8">
        <div class="bg-blue evalBlock mb-3">
          <div class="bigText">
            <div class="evalTitle">
              <h3><span class="hight">{{value.risques_catastrophes.length}}</span> {{$t("catastrophe")}}<span v-if="value.risques_catastrophes.length>1">s</span> {{$t("naturelle")}}<span v-if="value.risques_catastrophes.length>1">s</span> <span v-if="value.risques_catastrophes.length>0">:</span></h3>
            </div>
          </div>
          <b-table small hover :items="value.risques_catastrophes" :fields="risques_catastrophes_fields" :per-page="10" :current-page="risques_catastrophes_cp" ></b-table>
          <div class="text-right">
            <b-pagination v-model="risques_catastrophes_cp" :total-rows="value.risques_catastrophes.length" :per-page="10" aria-controls="my-table" align="right"></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row bg-blue evalBlock mb-3">
        <div class="col-md-3">
          <h3>{{$t("Inondations")}}</h3>
          <p><span :class="'badge badge-'+value.risques_innondations_badge">{{value.risques_innondations_badge_label}}</span></p>
          <p>{{$t("L'inondation est une submersion, rapide ou lente, d'une zone habituellement hors de l'eau. C’est un phénomène saisonnier qui trouve sa source dans des précipitations soutenues et durables, l’inondation peut aussi venir de la mer ou des eaux souterraines")}}.</p>
          <p>{{$t("En France, le risque inondation est le premier risque naturel par l’importance des dommages qu’il provoque, le nombre de communes concernées, l’étendue des zones inondables et les populations résidant dans ces zones. L’ensemble du territoire français est vulnérable, qu’il s’agisse des zones urbaines ou rurales, de plaine, de relief ou littorales")}}.</p>
          <p>{{value.risques_innondations_desc}}</p>
        </div>
        <div class="col-md-9">
          <iframe :src="ooftopMapApi+'risk/map?type=ppr&family=flood&point='+value.lat+','+value.lng+'&com_insee='+value.code_insee+'&_api_key='+ooftopMapApiKey+'&lang='+$i18n.locale" width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0" class="mt-4 mb-4"></iframe>
        </div>
      </div>
      <div class="row bg-blue evalBlock mb-3">
        <div class="col-md-3">
          <h3>{{$t("Mouvements de terrain")}}</h3>
          <p><span :class="'badge badge-'+value.risques_seismes_badge">{{value.risques_seismes_badge_label}}</span></p>
          <p>{{$t("Les mouvements de terrain sont des phénomènes naturels d’origines très diverses. Il en survient chaque année en France, d'importance et de type très divers (glissements de terrain, éboulements, effondrements, coulées de boue...)")}}.</p>
          <p>{{$t("Les mouvements de terrain présentent parfois un danger pour la vie des personnes et les dommages qu'ils occasionnent peuvent avoir des conséquences socio-économiques considérables")}}.</p>
          <p>{{value.risques_seismes_desc}}</p>
        </div>
        <div class="col-md-9">
          <iframe :src="ooftopMapApi+'risk/map?type=ppr&family=landslide&point='+value.lat+','+value.lng+'&com_insee='+value.code_insee+'&_api_key='+ooftopMapApiKey+'&lang='+$i18n.locale" width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0" class="mt-4 mb-4"></iframe>
        </div>
      </div>
      <div class="row bg-blue evalBlock mb-3">
        <div class="col-md-3">
          <h3>{{$t("Risques industriels")}}</h3>
          <p><span :class="'badge badge-'+value.risques_industriels_badge">{{value.risques_industriels_badge_label}}</span></p>
          <p>{{$t("Un risque industriel majeur est un événement accidentel se produisant sur un site industriel et entraînant des conséquences immédiates graves pour le personnel, les populations avoisinantes, les biens et/ou l'environnement")}}.</p>
          <p>{{value.risques_industriels_desc}}</p>
        </div>
        <div class="col-md-9">
          <iframe :src="ooftopMapApi+'risk/map?type=ppr&point='+value.lat+','+value.lng+'&family=industrial&com_insee='+value.code_insee+'&_api_key='+ooftopMapApiKey+'&lang='+$i18n.locale" width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0" class="mt-4 mb-4"></iframe>
        </div>
      </div>
      <div class="row bg-blue evalBlock mb-3">
        <div class="col-md-3">
          <h3>{{$t("Risques climatiques")}}</h3>
          <p><span :class="'badge badge-'+value.risques_avalanche_badge">{{value.risques_avalanche_badge_label}}</span></p>
          <p>{{$t("Les risques climatiques sont liés à des conditions extrêmes de changement de température notamment dû au réchauffement climatique. Ce qui entraine l’expansion des feux de forêt, l’augmentation du nombre de tornades, la puissance des avalanches etc… ")}}</p>
          <p>{{$t("La vulnérabilité des territoires dépend également de l’exposition des différents pans de l’économie locale. Le secteur primaire est le plus impacté par les risques climatiques")}}.</p>
          <p>{{value.risques_avalanche_desc}}</p>
        </div>
        <div class="col-md-9">
          <iframe :src="ooftopMapApi+'risk/map?type=ppr&point='+value.lat+','+value.lng+'&family=climatological&com_insee='+value.code_insee+'&_api_key='+ooftopMapApiKey+'&lang='+$i18n.locale" width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0" class="mt-4 mb-4"></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EvaluationRisques',
  components: {},
  data() {
    return {
      nodata:this.$i18n.t('Données insuffisantes'),
      risques_catastrophes_cp:1,
      risques_catastrophes_fields:[
        {
          key: 'type',
          label: this.$i18n.t('Type de catastrophe'),
          sortable: true
        },
        {
          key: 'code_catnat',
          label: this.$i18n.t('Code national CATNAT'),
          sortable: true
        },
        {
          key: 'debut',
          label: this.$i18n.t('Début le'),
          sortable: true,
        },
        {
          key: 'fin',
          label: this.$i18n.t('Fin le'),
          sortable: true,
        },
        {
          key: 'arrete_jo',
          label: this.$i18n.t('Arrêté JO du'),
          sortable: true,
        }
      ],
    }
  },
  props:{
    value : Object,
    rights: Object,
    ooftopMapApi : String,
    ooftopMapApiKey : String
  },
  watch: {
  },
  computed: {
  },
  methods: {
  },
  mounted(){
  }
}
</script>